import { InputLabel, TextField } from '@material-ui/core';

import React, { ChangeEvent, useEffect, useState } from 'react';
import { useStyles } from './styles';
import { CloseIcon } from './CloseIcon';

interface IProps {
  selectedValue?: string;
  onChange: (value: string) => void;
  open: () => void;
  toggle: () => void;
  isOpen: boolean;
}

export default function Search({ onChange, selectedValue, open, toggle, isOpen }: IProps) {
  const classes = useStyles();
  const [value, setValue] = useState<string>(selectedValue);

  const handleOnChange = (event: ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setValue(value);
    onChange(value);
  };

  useEffect(() => {
    if (!selectedValue) {
      return;
    }
    setValue(selectedValue);
  }, [selectedValue]);

  return (
    <>
      <InputLabel htmlFor="select-search" className={classes.label}>
        Produto
      </InputLabel>
      <div className={classes.searchContainer}>
        <TextField
          id="select-search"
          placeholder={'Pesquisar'}
          value={value}
          onChange={handleOnChange}
          onClick={open}
          className={classes.textField}
        />
        <CloseIcon action={toggle} isOpen={isOpen} />
      </div>
    </>
  );
}
